export default {"src":"/_next/static/media/green.2b32cc90.svg","height":54,"width":54,"blurWidth":0,"blurHeight":0};